<template>
    <div class="echarts">
        <div v-show="targetTable.length > 0" id="myChart" :style="{height: tableHeight+'px'}"></div>
        <div v-show="targetTable.length === 0" class="echarts-null" :style="{height: tableHeight+'px'}">暂无数据</div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    props: {
        tableHeight: {
            type: Number,
            default: 0
        }
    },
    computed: {
        ...mapGetters(["leftIndex", "targetTable", "tableData", "checkIndicators"]),
    },
    watch: {
        leftIndex: {
            handler(value) {
                this.initData()
            },
            deep: true
        },
        checkIndicators: {
            handler(value) {
                this.initData()
            },
            deep: true
        },
        tableData: {
            handler(value) {
                this.initData()
            },
            deep: true
        }
    },
    mounted() {
        if (this.tableHeight != 0) {
            this.initData()
        }
    },
    methods: {
        ...mapActions(["GetTargetTable"]),
        initData() {
            const rLoading = this.openLoading();
            this.GetTargetTable()
                .then( () => {
                    this.setData()
                    rLoading.close()
                })
        },
        /**
         * 处理数据
         */
        setData() {
            let arr = []
            if (this.leftIndex === 0) {
                arr = JSON.parse(JSON.stringify(this.checkIndicators))
            } else if (this.leftIndex === 1) {
                arr = JSON.parse(JSON.stringify(this.tableData))
            }
            let legend = [], xAxis = [], series = [];
            if (this.targetTable.length > 0) {
                arr.forEach(item => {
                    legend.push(item.targetNameCh)
                    series.push({
                        name: item.targetNameCh,
                        id: item.datasourceId,
                        type: 'line',
                        connectNulls: true,
                        data: []
                    })
                });
                if (this.targetTable.length > 0) {
                    this.targetTable.forEach(item => {
                        xAxis.unshift(item.date)
                        series.forEach(citem => {
                            const list = item.targetList || []
                            const findItem = list.find( ditem => ditem.datasourceId === citem.id)
                            const value = findItem ? findItem.value : ""
                            citem.data.unshift(value)
                        })
                    })
                }
                this.getMapData(legend, xAxis, series)
            } else {
                this.$echarts.init(document.getElementById('myChart')).dispose(); // 销毁实例
            }
        },
        /**
         * 获取图形信息
         */
        getMapData(legend, xAxis, series) {
            let option = {
                title: {
                    text: ""
                },
                tooltip: {
                    trigger: 'axis',
                    confine: true
                },
                legend: {
                    x: 'center',      //可设定图例在左、右、居中
                    y: 'top',
                    padding: [0, 10, 0, 10], // 图例位置
                    data: legend,
                    type: 'scroll',            // 设置图例翻页
                    icon: 'rect',
                    itemWidth: 12,             // 图例图形宽度
                    itemHeight: 10,
                    orient: 'horizontal',     // 图例横向排布
                    data: legend,              // title是一个列表，存着图例的数据
                    textStyle: {
                        fontSize: 12
                    },
                    itemGap: 20
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    // axisLabel: {
                    //     rotate: 25,
                    // },
                    data: xAxis
                },
                yAxis: {
                    type: 'value'
                },
                series: series,
                dataZoom: [{
                    type: 'inside',//图表下方的伸缩条
                    show: true, //是否显示
                    realtime: true, //拖动时，是否实时更新系列的视图
                    start: 0, //伸缩条开始位置（1-100），可以随时更改
                    end: 100, //伸缩条结束位置（1-100），可以随时更改
                }],
                grid: {
                    x: 80,
                    y: 50,
                    x2: 10,
                    y2: 50
                },
            }
            this.drawChart(option);
        },
        /**
         * 加载echarts
         */
        drawChart(option) {
            this.$echarts.init(document.getElementById('myChart')).dispose(); // 销毁实例
            let myChart = this.$echarts.init(document.getElementById("myChart"));
            myChart.setOption(option);
        }
    }
}
</script>

<style lang="less" scoped>
.echarts {
    padding-top: 54px;
    padding-right: 10px;
    overflow: hidden;
}
#myChart {
    width: 100%;
    padding-right: 40px;
    box-sizing: border-box;
}
.echarts-null {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
